export function getLocalStorage() {
  try {
    return window?.localStorage
  } catch (error) {
    return false
  }
}
